import { Divider, TextField } from "@mui/material";
import { useCallback, useEffect, useRef, useState } from "react";
import ReactSignatureCanvas from "react-signature-canvas";
import Button from "../editor/toolbar/Button";

interface EvaluationSignatureProps {
  signatureFile: string;
  setSignatureFile: React.Dispatch<React.SetStateAction<string>>;
  signatureText: string;
  setSignatureText: React.Dispatch<React.SetStateAction<string>>;
}

const EvaluationSignature = (props: EvaluationSignatureProps) => {
  const canvasRef = useRef<ReactSignatureCanvas>(null);
  const { signatureFile, setSignatureFile } = { ...props };
  const { setSignatureText } = { ...props };
  const [writtenValue, setWrittenValue] = useState<string>("");

  const handleResetSignature = useCallback(() => {
    setSignatureText("");
    setWrittenValue("");
    setSignatureFile("");

    canvasRef.current?.clear();
  }, [setWrittenValue, setSignatureFile, setSignatureText]);

  const handleSetSignature = useCallback(() => {
    const dataUrl = canvasRef.current?.toDataURL("image/png");

    setSignatureFile(dataUrl ?? "");
    setSignatureText("");
    setWrittenValue("");
  }, [setWrittenValue, setSignatureFile, setSignatureText]);

  const handleWriteSignature = useCallback(
    (value: string) => {
      if (signatureFile !== "") {
        canvasRef.current?.clear();
        setSignatureFile("");
      }

      setWrittenValue(value);
    },
    [setWrittenValue, signatureFile, setSignatureFile]
  );

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSignatureText(writtenValue.trim());
    }, 500);
    return () => clearTimeout(timeout);
  }, [writtenValue, setSignatureText]);

  return (
    <>
      <label className="pb-2" data-html2canvas-ignore>
        <span className="required">Signature</span>
        <TextField
          value={writtenValue}
          className="mb-2"
          onChange={(e) => handleWriteSignature(e.target.value)}
          placeholder="Enter name or sign below..."
          inputProps={{
            maxLength: 64,
          }}
        />
        <ReactSignatureCanvas
          canvasProps={{
            width: 700,
            height: 200,
            className: "border-signature",
          }}
          onEnd={handleSetSignature}
          ref={canvasRef}
        />

        <Divider color="info" />
      </label>
      <div className="flex justify-content-end" data-html2canvas-ignore>
        <Button
          className="blue-button"
          disabled={!signatureFile && !writtenValue}
          onClick={handleResetSignature}
        >
          CLEAR
        </Button>
      </div>
    </>
  );
};

export { EvaluationSignature };
